package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteSummary
import com.milta.feature.route.domain.repository.RouteRepository

class StartRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(id: String, loadingDiscrepancyNote: String? = null): RouteSummary =
        repository.startRoute(id, loadingDiscrepancyNote)
}
